import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import ProjectIntroduction from '@/components/ProjectIntroduction'
import DataCenter from '@/components/DataCenter'
import DocumentCenter from '@/components/DocumentCenter'
import PracticeCenter from '@/components/PracticeCenter'
import ContactUs from '@/components/ContactUs'

// 二级路由
// 项目介绍

import framework from '@/components/tabs/framework'
import team from '@/components/tabs/team'
import bigEvent from '@/components/tabs/bigEvent'
// 实践中心
import growthThinking from '@/components/tabs/growthThinking'
import psychological from '@/components/tabs/psychological'
// 数据中心
import sampling from '@/components/tabs/sampling'
import process from '@/components/tabs/process'
import diagram from '@/components/tabs/diagram'
import partialData from '@/components/tabs/partialData'
import dataApply from '@/components/tabs/dataApply'
// 文档中心
import wholeIdea from '@/components/tabs/wholeIdea'
import report from '@/components/tabs/report'
import found from '@/components/tabs/found'
import advice from '@/components/tabs/advice'

// 三级路由
import psychological1 from '@/components/psychological/list1'
import psychological2 from '@/components/psychological/list2'
import psychological3 from '@/components/psychological/list3'
import growthThinking1 from '@/components/growthThinking/list1'
import growthThinking2 from '@/components/growthThinking/list2'
import growthThinking3 from '@/components/growthThinking/list3'
import growthThinking4 from '@/components/growthThinking/list4'
import growthThinking5 from '@/components/growthThinking/list5'
import growthThinking6 from '@/components/growthThinking/list6'
import growthThinking7 from '@/components/growthThinking/list7'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
    },
    {
      path: '/index',
      component: Index,

      // redirect: '/Index',
    }, {
      path: '/ProjectIntroduction',
      component: ProjectIntroduction,
      redirect: '/ProjectIntroduction/framework',
      children: [
        {
          path: 'framework',
          name: 'framework',
          component: framework,
        }, {
          path: 'team',
          name: 'team',
          component: team,
        }, {
          path: 'bigEvent',
          name: 'bigEvent',
          component: bigEvent,
        },
      ]
    }, {
      path: '/DataCenter',
      component: DataCenter,
      redirect: '/DataCenter/sampling',
      children: [
        {
          path: 'sampling',
          name: 'sampling',
          component: sampling,
        }, {
          path: 'process',
          name: 'process',
          component: process,
        }, {
          path: 'diagram',
          name: 'diagram',
          component: diagram,
        }, {
          path: 'partialData',
          name: 'partialData',
          component: partialData,
        }, {
          path: 'dataApply',
          name: 'dataApply',
          component: dataApply,
        },
      ]
    }, {
      path: '/DocumentCenter',
      component: DocumentCenter,
      redirect: '/DocumentCenter/wholeIdea',
      children: [
        {
          path: 'wholeIdea',
          name: 'wholeIdea',
          component: wholeIdea,
        }, {
          path: 'report',
          name: 'report',
          component: report,
        }, {
          path: 'found',
          name: 'found',
          component: found,
        }, {
          path: 'advice',
          name: 'advice',
          component: advice,
        },
      ]
    }, {
      path: '/PracticeCenter',
      component: PracticeCenter,
      redirect: '/PracticeCenter/growthThinking',
      children: [
        {
          path: 'growthThinking',
          name: 'growthThinking',
          component: growthThinking,
          children: [
            {
              path: '1',
              name: 'growthThinking1',
              component: growthThinking1
            },
            {
              path: '2',
              name: 'growthThinking2',
              component: growthThinking2
            },
            {
              path: '3',
              name: 'growthThinking3',
              component: growthThinking3
            },
            {
              path: '4',
              name: 'growthThinking4',
              component: growthThinking4
            },
            {
              path: '5',
              name: 'growthThinking5',
              component: growthThinking5
            },
            {
              path: '6',
              name: 'growthThinking6',
              component: growthThinking6
            },
            {
              path: '7',
              name: 'growthThinking7',
              component: growthThinking7
            },
            {
              path: '8',
              name: 'growthThinking8',
              component: psychological1
            },
            {
              path: '9',
              name: 'growthThinking9',
              component: psychological2
            },
            {
              path: '10',
              name: 'growthThinking10',
              component: psychological3
            }
          ]
        }
      ]
    }, {
      path: '/ContactUs',
      component: ContactUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js